import Schema from 'AppReact/schema';
import { tableOrder } from 'types';

export default {
  selectedOrdersCount: Schema('integer', 'primitive', { defaultValue: 0 }),
  selectedTab: Schema('string', 'primitive', { defaultValue: '' }),
  selectedOrdersList: Schema(tableOrder, 'array', { defaultValue: [] }),
  orders: Schema(tableOrder, 'array',  { defaultValue: [] }),
}